<template>
  <div v-if="!isLoading" class="container-fluid new_Header">
    <nav class="breadcrumb-Style">
      <ol class="breadcrumb">
        <li class="breadcrumb-item mx-2"><router-link  to="/">{{$t('maintenanceDetails.breadcrumb_1')}}</router-link></li>
        <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
        <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
        <li class="active mx-2 almarai-bold">
          <router-link to="/maintenanceslist">
            {{$t('maintenanceDetails.breadcrumb_2')}}
          </router-link>
        </li>
        <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
        <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
        <li class="active mx-2 almarai-bold" aria-current="page">
          {{$t('maintenanceDetails.breadcrumb_3')}}
        </li>
        <li class="help" @click.prevent="openPoup">
          <div>
            <img src="/assets/images/icons/helpCircle.png" class="questionMark" alt="">
            <span class="mx-2">{{$t('maintenances.help')}}</span>
          </div>
        </li>
      </ol>
    </nav>
  </div>
  <div class="container pt-3">
    <div class="row" v-if="step == 1">
      <div class="col">

        <div class="row">
          <div class="col-12">
            <div v-if="hasError" class="text-center">
              <errorAlert :alertMessage="message" :errorNumber="errorNumber" />
            </div>
          </div>
        </div>
        <div v-if="isLoading" class="text-center">
          <mainloader /> 
        </div>

        <div v-else class="row">
          <div class="col">
            <div class="row p-3">
              <div class="col-12 col-lg-6 d-block d-lg-none">
                <h6>{{$t('maintenances.orderStatus')}}</h6>
                <div class="row">
                  <div class="col">
                    <div class="card br-radius-16 position-R">
                      <img src="/assets/images/icons/Artboard.png" class="slogan" alt="">
                      <div class="card-body text-center">
                        <div class="row"  v-if="row.status == 'new'">
                          <div class="col-12">
                            <div>
                              <img src="/assets/images/icons/search-Icon.png" class="search-Icon" alt="">
                            </div>
                            <div class="technician-style">
                              <span>{{$t('maintenances.technician')}}</span>
                              <span class="mx-1">🔍</span>
                            </div>
                            <div class="confirmed">{{$t('maintenances.confirmed')}}</div>
                            <div class="confirmed">{{$t('maintenances.area')}}</div>
                          </div>
                        </div>

                        <div class="row" v-if="row.Provider">
                          <div class="col-12">
                            <div class="row" v-if="row.status == 'assigned'">
                              <div class="col">
                                <div>
                                  <img src="/assets/images/icons/moto.png" class="search-Icon" alt="">
                                </div>
                                <div class="technician-style">
                                  <!-- <span>{{$t('maintenances.technician')}}</span> -->
                                  <span>{{$t('maintenanceDetails.theTechnician')}}</span>
                                  <span class="mx-1">🔧</span>
                                </div>
                                <div class="confirmed">{{$t('maintenances.confirmed')}}</div>
                                <div class="confirmed">{{$t('maintenances.area')}}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row" v-if="row.status == 'done' || row.status == 'admin_done'">
                          <div class="col-12">
                            <div>
                              <img src="/assets/images/icons/tick-circle-gold.png" class="circleGold" alt="">
                            </div>
                            <div class="technician-style">
                              <span>{{$t('maintenanceDetails.successfullyResolved')}}</span>
                            </div>
                            <!-- <div class="confirmed">{{$t('maintenances.confirmed')}}</div>
                            <div class="confirmed">{{$t('maintenances.area')}}</div> -->
                          </div>
                        </div>

                        <div class="row" v-if="['client_canceled','provier_canceled'].indexOf(row.status) != -1">
                          <div class="text-center">
                            <img src="/assets/images/icons/Erorr_img.png" class="max-50" alt="">
                          </div>
                          <div class="col">
                            {{status[row.status]}}
                          </div>
                        </div>

                        <div class="row" v-if="['deposit_issue','hold','payment_issue','scheduled','under_review','waiting_deposit','waiting_payment'].indexOf(row.status) != -1">
                          <div class="text-center">
                            <img src="/assets/images/icons/wating_img.png" class="max-50" alt="">
                          </div>
                          <div class="col">
                            {{status[row.status]}}
                          </div>
                        </div>

                        <div class="row pt-3">
                          <div class="col-12">
                            <span :class="(['new', 'assigned', 'arrived', 'done', 'hold', 'scheduled'].indexOf(row.status) != -1)? 'statusLine bg-Orange':'statusLine'"></span>
                            <span :class="(['assigned', 'arrived', 'done'].indexOf(row.status) != -1)? 'statusLine bg-Orange':'statusLine'"></span>
                            <span :class="(['arrived', 'done'].indexOf(row.status) != -1)? 'statusLine bg-Orange':'statusLine'"></span>
                            <span :class="(['done'].indexOf(row.status) != -1)? 'statusLine bg-Orange':'statusLine'"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row pt-5 justify-content-center">
                  <div class="col-11 content-end text-center" v-if="row.deposit !=0 && row.status == 'waiting_deposit' || row.status == 'deposit_issue'">
                    <div @click.prevent="poupPaymentOrder" class="form-control btn-green">{{$t('maintenanceDetails.title_5')}} {{row.deposit}} {{$t('maintenanceDetails.title_7')}} </div>
                  </div>
                  <div class="col-11 text-center" v-if="row.finalPayment != 0 && row.status == 'payment_issue' || row.status == 'waiting_payment'">
                    <div @click.prevent="next" class="form-control btn-green">{{$t('maintenanceDetails.title_5')}} {{row.finalPayment}} {{$t('maintenanceDetails.title_7')}} </div>
                  </div>
                  <!-- <div class="col-11 col-md-5 text-center mt-3" v-if="row.status !='done' && row.status !='client_canceled' && row.status !='provier_canceled'" @click="poupCanenllOrder"> 
                    <button class="form-control black-button almarai-bold padding-style">{{$t('maintenanceDetails.title_6')}}</button>
                  </div> -->
                </div>
              </div>

              <div class="col-12 col-lg-6">
                <div class="row" v-if="row.Provider && (row.status !='done' || row.stauts !='admin_done') && row.status !='client_canceled' && row.status !='provier_canceled'">
                  <div class="col-12">
                    <div class="row">
                      <div class="col">
                        <span class="almarai-bold">{{$t('maintenances.technicalInformation')}}</span>
                      </div>
                      <div class="col-auto provider_Line" @click.prevent="requestChangeProvider" v-if="row.status !='done' && row.status !='admin_done'">
                        <span class="changeProvider">{{$t('maintenanceDetails.request_ChangeProvider')}}</span>
                      </div>
                    </div>
                    <div class="card bg-maintenance">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-auto" v-if="row.Provider.avatar">
                            <div class="provider-img">
                              <img :src="MEDIA_URL+row.Provider.avatar" class="w-100" alt="">
                            </div>
                          </div>
                          <div class="col p-0">
                            <div>{{row.Provider.name}}</div>
                            <!-- begin:rateStars_Provider -->
                            <div id="providerRate"></div>
                            <!-- end:rateStars_Provider -->
                          </div>
                          <div class="col-auto content-center ps-0">
                            <a :href="'https://wa.me/+966'+row.Provider.mobile" target="_blank">
                              <img src="/assets/images/icons/WhatsApp-1.png" class="max-24" alt="">
                            </a>
                          </div>
                          <div class="col-auto content-center">
                            <a :href="'tel:+966'+row.Provider.mobile" target="_blank">
                              <img src="/assets/images/icons/mobile-calling.png" class="max-24" alt="">
                            </a>
                          </div>
                          <div v-if="currentChat" class="col-auto content-center mouse-hand" @click.prevent="toggleDiv">
                            <img src="/assets/images/icons/message.png" class="max-24" alt="">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row pt-3">
                  <div class="col-12">
                    <h6>{{$t('maintenances.orderDetails')}}</h6>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <div class="card bg-maintenance">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-12 mb-3">
                            <span class="fonttext-14 almarai-bold">{{$t('maintenances.order_number')}}:</span>
                            <span class="fonttext-14 almarai-bold"># {{row.id}}</span>
                            <div class="fontGray-73">
                              <span>{{$t('applicant')}} :</span>
                              <span class="mx-2">{{row.User.name}}</span>
                            </div>
                            <div class="fontGray-73">
                              <span>{{$t('maintenances.phoneNumber')}}</span> :
                              <span>{{row.User.mobile}}</span>
                            </div>
                            <div class="fontGray-73">
                              <span>{{$t('maintenanceDetails.serviceRequest')}}</span>
                              <span>{{moment(row.createdAt).format('LLL')}}</span>
                            </div>
                            <div class="fontGray-73" v-if="row.doneTime">
                              <span>{{$t('maintenanceDetails.doneTime')}}</span>
                              <span>{{moment(row.doneTime).format('LLL')}}</span>
                            </div>
                            <div class="fontGray-73" v-if="row.cancelTime">
                              <span>{{$t('maintenanceDetails.cancelOrder')}}</span>
                              <span>{{moment(row.cancelTime).format('LLL')}}</span>
                            </div>
                          </div>
                        </div>
                        <hr class="m-0">
                        <div class="row pt-2">
                          <div class="col-12 mb-3">
                            <strong> {{$t('maintenances.service_name')}} </strong>
                            <div class="row">
                              <div class="col fontGray-73">
                                <div> {{(row.MaintenanceIssue)? row.MaintenanceIssue.name : 'غير معروف'}} </div>
                                <div> {{ row.title }} </div>
                                <!-- <strong> {{ $t('maintenances.title') }}:</strong> -->
                                <div>{{ row.description }}</div>
                                <!-- <strong>{{ $t('maintenances.description') }}:</strong> -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row pt-3" v-if="row.deposit">
                  <div class="col-12">
                    <h6>{{$t('maintenances.seriousnessPrice')}}</h6>
                    <div class="row">
                      <div class="col-12">
                        <div class="card bg-maintenance">
                          <div class="card-body font-gray-73">
                            <div class="row">
                              <div class="col">
                                {{$t('maintenances.amountPaid')}}
                              </div>
                              <div class="col-auto">
                                <span v-if="row.couponAccepted">
                                  {{row.depositAfterDiscount}} {{$t('maintenances.title_22')}}
                                </span>
                                <span v-else>
                                  {{row.deposit}} {{$t('maintenances.title_22')}}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                

                <!-- <div class="row pt-3">
                  <div v-if="row.image" class="col-12 mb-3">
                    <strong>{{$t('maintenances.image')}}:</strong> <br>
                    <img :src="MEDIA_URL+row.image" style="max-width: 100%;" alt="">
                  </div>
                </div> -->

                <!-- <hr class="line-color"> -->
                <!-- <div class="almarai-bold pt-3">{{$t('maintenanceDetails.breadcrumb_3')}}</div>
                <div class="row pt-3">
                  <div class="col border-dash px-3">
                    <div class="row">
                      <div class="col position-R">
                        <div class="gray-color">{{moment(row.createdAt).format('h:mm a')}}</div>
                        <div class="fonttext-14 almarai-regular">{{$t('maintenanceDetails.title_4')}}</div>
                          <i v-if="currentStage == 'created'" class="fa-solid fa-circle-dot currentStatus button-steps"></i>
                        <i v-else class="fa-solid fa-circle-dot gray-B4  button-steps"></i>
                      </div>
                    </div>

                    <div class="row pt-4" v-if="row.assignTime" >
                      <div class="col position-R">
                        <div class="gray-color">{{moment(row.assignTime).format('h:mm a')}}</div>
                        <i  v-if="currentStage == 'assign'" class="fa-solid fa-circle-dot currentStatus button-steps"></i>
                        <i  v-else class="fa-solid fa-circle-dot gray-B4  button-steps"></i>
                        <div class="fonttext-14 almarai-regular pb-2">{{status.assigned}}</div>

                        <div class="row" v-if="row.Provider">
                          <div class="col-3 col-md-1 text-center ps-0" v-if="row.Provider.avatar">
                            <div class="provider-img">
                              <img :src="MEDIA_URL+row.Provider.avatar" class="w-100" alt="">
                            </div>
                          </div>
                          <div v-else class="col-auto text-center ps-0">
                            <i  class="bi bi-person font-36 pe-2"></i>
                          </div>
                          <div class="col-6">
                            <div>{{row.Provider.name}}</div>
                            <div>{{row.Provider.mobile}}</div>
                            <div class="text-style">{{$t('maintenanceDetails.technician')}}</div>
                            <div id="providerRate"></div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row pt-4" v-if="row.arriveTime">
                      <div class="col position-R">
                        <div class="gray-color">{{moment(row.arriveTime).format('h:mm a')}}</div>
                        <i  v-if="currentStage == 'arrive'" class="fa-solid fa-circle-dot currentStatus button-steps"></i>
                        <i  v-else class="fa-solid fa-circle-dot gray-B4 button-steps"></i>
                        <div>{{status.arrived}}</div>
                      </div>
                    </div>

                    <div class="row pt-4" v-if="row.doneTime">
                      <div class="col position-R">
                        <i  v-if="currentStage == 'done'" class="fa-solid fa-circle-dot currentStatus button-steps"></i>
                        <i  v-else class="fa-solid fa-circle-dot gray-B4 button-steps"></i>
                        <span class="gray-color">{{moment(row.doneTime).format('h:mm a')}}</span>
                        <div>{{status.done}}</div>
                      </div>
                    </div>                    
                  </div>
                </div> -->
                <div class="row pt-3" v-if="row.status == 'done' || row.status == 'admin_done'">
                  <div class="col">
                    <label for="">{{$t('maintenanceDetails.serviceCost')}}</label>
                    <div class="row pt-2">
                      <div class="col">
                        <div class="card bg-maintenance">
                          <div class="card-body">
                            <div class="row">
                              <div class="col">
                                <span>{{$t('maintenanceDetails.laborCost')}}</span>
                              </div>
                              <div class="col-auto" v-if="row.couponAccepted">
                                {{row.priceAfterDiscount}}
                                <span class="mx-2">
                                  <img src="/assets/images/icons/riyal.png" class="max-16" alt="">
                                </span>
                              </div>
                              <div v-else class="col-auto">
                                {{row.price}}
                                <span class="mx-2">
                                  <img src="/assets/images/icons/riyal.png" class="max-16" alt="">
                                </span>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col">
                                <span>{{$t('maintenanceDetails.spareParts')}}</span>
                              </div>
                              <div class="col-auto">
                                {{row.partsPrice}}
                                <span class="mx-2">
                                  <img src="/assets/images/icons/riyal.png" class="max-16" alt="">
                                </span>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col">
                                <span>{{$t('maintenanceDetails.totalAmount')}}</span>
                              </div>
                              <div class="col-auto">
                                {{row.finalPayment}}
                                <span class="mx-2">
                                  <img src="/assets/images/icons/riyal.png" class="max-16" alt="">
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="billUrl" class="row justify-content-center pt-2">
                  <div class="col-12">
                    <a :href="BASE_URL+billUrl" target="_blank" type="application/pdf">
                      <div class="button-bill">
                        <!-- <img src="/assets/images/icons/receipt-text.png" class="max-16" alt=""> -->
                        <span class="mx-2">{{$t('invoiceDetails')}}</span>
                      </div>
                    </a>
                  </div>
                </div>

                <div class="row pt-2" v-if="row.doneNotice">
                  <div class="col">
                    <h6 class="small-Font">{{$t('maintenanceDetails.providerNotes')}}</h6>
                    <div class="card bg-maintenance">
                      <div class="card-boby p-2">
                        <div class="almarai-bold gray-color-76">{{row.doneNotice}}</div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="row pt-2 justify-content-center" v-if="row.imageBefore || row.imageAfter">
                  <div class="col-12">
                    <h6 class="almarai-bold pb-1">{{$t('maintenanceDetails.imageBefore')}}</h6>
                    <img :src="MEDIA_URL+row.imageBefore" class="w-100 max-height-img" alt="">
                  </div>
                  <div class="col-12">
                    <h6 class="almarai-bold pt-2">{{$t('maintenanceDetails.imageAfter')}}</h6>
                    <img :src="MEDIA_URL+row.imageAfter" class="w-100 max-height-img" alt="">
                  </div>
                </div>

                <div class="row pt-3 d-md-none justify-content-center">
                  <div class="col-10 col-md-5 btn-green almarai-bold text-center" v-if="(row.status =='done' || row.status == 'admin_done') && !row.rate" @click.prevent="ratingPoup"> 
                    {{$t('maintenanceDetails.evaluateExperience')}}
                  </div>
                </div>

                <!-- <div class="row pt-5 justify-content-center">
                  <div class="col-11 col-md-5 content-end text-center" v-if="row.deposit !=0 && row.status == 'waiting_deposit' || row.status == 'deposit_issue'">
                    <div @click.prevent="poupPaymentOrder" class="form-control btn-green">{{$t('maintenanceDetails.title_5')}} {{row.deposit}} {{$t('maintenanceDetails.title_7')}} </div>
                  </div>
                  <div class="col-11 col-md-5 text-center" v-if="row.finalPayment != 0 && row.status == 'payment_issue' || row.status == 'waiting_payment'">
                    <div @click.prevent="next" class="form-control btn-green">{{$t('maintenanceDetails.title_5')}} {{row.finalPayment}} {{$t('maintenanceDetails.title_7')}} </div>
                  </div>
                  <div class="col-11 col-md-5 text-center mt-3" v-if="row.status !='done' && row.status !='client_canceled' && row.status !='provier_canceled'" @click="poupCanenllOrder"> 
                    <button class="form-control black-button almarai-bold padding-style">{{$t('maintenanceDetails.title_6')}}</button>
                  </div>
                  <div class="col-11 col-md-5 text-center mt-3" v-if="row.status =='done' && !row.rate" @click.prevent="ratingPoup"> 
                    <div class="form-control black-button almarai-bold padding-style">
                      {{$t('maintenanceDetails.evaluateExperience')}}
                    </div>
                  </div>
                </div> -->
              </div>

              <div class="col-12 col-lg-6 d-none d-lg-block">
                <h6>{{$t('maintenances.orderStatus')}}</h6>
                <div class="row">
                  <div class="col">
                    <div class="card br-radius-16 position-R">
                      <img src="/assets/images/icons/Artboard.png" class="slogan" alt="">
                      <div class="card-body text-center">

                        <div class="row"  v-if="row.status == 'new'">
                          <div class="col-12">
                            <div>
                              <img src="/assets/images/icons/search-Icon.png" class="search-Icon" alt="">
                            </div>
                            <div class="technician-style">
                              <span>{{$t('maintenances.technician')}}</span>
                              <span class="mx-1">🔍</span>
                            </div>
                            <div class="confirmed">{{$t('maintenances.confirmed')}}</div>
                            <div class="confirmed">{{$t('maintenances.area')}}</div>
                          </div>
                        </div>

                        <div class="row" v-if="row.Provider">
                          <div class="col-12">
                            <div class="row" v-if="row.status == 'assigned'">
                              <div class="col">
                                <div>
                                  <img src="/assets/images/icons/moto.png" class="search-Icon" alt="">
                                </div>
                                <div class="technician-style">
                                  <!-- <span>{{$t('maintenances.technician')}}</span> -->
                                  <span>{{$t('maintenanceDetails.theTechnician')}}</span>
                                  <span class="mx-1">🔧</span>
                                </div>
                                <div class="confirmed">{{$t('maintenances.confirmed')}}</div>
                                <div class="confirmed">{{$t('maintenances.area')}}</div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row" v-if="row.Provider">
                          <div class="col-12">
                            <div class="row" v-if="row.status == 'arrived'">
                              <div class="col">
                                <div>
                                  <img src="/assets/images/icons/worker-yellow.png" alt="">
                                </div>
                                <div class="technician-style">
                                  <span>{{$t('maintenanceDetails.theTechnician')}}</span>
                                  <span class="mx-1">🔧</span>
                                </div>
                                <div class="confirmed">{{$t('maintenances.confirmed')}}</div>
                                <div class="confirmed">{{$t('maintenances.area')}}</div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row" v-if="row.status == 'done' || row.status == 'admin_done'">
                          <div class="col">
                            <div>
                              <img src="/assets/images/icons/tick-circle-gold.png" class="circleGold" alt="">
                            </div>
                            <div class="technician-style">
                              <span>{{$t('maintenanceDetails.successfullyResolved')}}</span>
                            </div>
                            <!-- <div class="confirmed">{{$t('maintenances.confirmed')}}</div>
                            <div class="confirmed">{{$t('maintenances.area')}}</div> -->
                          </div>
                        </div>

                        <div class="row" v-if="['client_canceled','provier_canceled'].indexOf(row.status) != -1">
                          <div class="text-center">
                            <img src="/assets/images/icons/Erorr_img.png" class="max-60" alt="">
                          </div>
                          <div class="col pt-3 almarai-bold">
                            {{status[row.status]}}
                          </div>
                        </div>

                        <div class="row" v-if="['deposit_issue','hold','payment_issue','scheduled','under_review','waiting_deposit','waiting_payment'].indexOf(row.status) != -1">
                          <div class="text-center">
                            <img src="/assets/images/icons/wating_img.png" class="max-60" alt="">
                          </div>
                          <div class="col almarai-bold pt-3">
                            <span v-if="row.status == 'scheduled'">{{$t('maintenanceDetails.demand')}}</span>
                            {{status[row.status]}}
                            <span v-if="row.status == 'scheduled'" >{{$t('maintenanceDetails.future')}}</span>
                          </div>
                          <div v-if="row.scheduleDate"> 
                            <!-- <span class="mx-2 fontGray-73">{{$t('maintenanceDetails.orderScheduled')}}</span> -->
                            <!-- <span class="fontGray-73">
                              {{moment(row.scheduleDate).format('LLL')}}
                            </span> -->
                          </div>
                        </div>

                        <div class="row pt-3">
                          <div class="col-12">
                            <span :class="(['new', 'assigned', 'arrived', 'done', 'hold', 'scheduled', 'admin_done'].indexOf(row.status) != -1)? 'statusLine bg-Orange':'statusLine'"></span>
                            <span :class="(['assigned', 'arrived', 'done', 'admin_done'].indexOf(row.status) != -1)? 'statusLine bg-Orange':'statusLine'"></span>
                            <span :class="(['arrived', 'done' ,'admin_done'].indexOf(row.status) != -1)? 'statusLine bg-Orange':'statusLine'"></span>
                            <span :class="(['done','admin_done'].indexOf(row.status) != -1)? 'statusLine bg-Orange':'statusLine'"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row pt-5 justify-content-center">
                  <div class="col-11 content-end text-center" v-if="row.deposit !=0 && row.status == 'waiting_deposit' || row.status == 'deposit_issue'">
                    <div @click.prevent="poupPaymentOrder" class="form-control btn-green">{{$t('maintenanceDetails.title_5')}} {{row.deposit}} {{$t('maintenanceDetails.title_7')}} </div>
                  </div>
                  <div class="col-11 text-center" v-if="row.finalPayment != 0 && row.status == 'payment_issue' || row.status == 'waiting_payment'">
                    <div @click.prevent="next" class="form-control btn-green">{{$t('maintenanceDetails.title_5')}} {{row.finalPayment}} {{$t('maintenanceDetails.title_7')}} </div>
                  </div>
                  <!-- <div class="col-11 col-md-5 text-center mt-3" v-if="row.status !='done' && row.status !='client_canceled' && row.status !='provier_canceled'" @click="poupCanenllOrder"> 
                    <button class="form-control black-button almarai-bold padding-style">{{$t('maintenanceDetails.title_6')}}</button>
                  </div> -->
                  <div class="col-10 col-md-5 text-center" v-if="(row.status =='done' || row.status == 'admin_done') && !row.rate" @click.prevent="ratingPoup"> 
                    <div class="form-control almarai-bold btn-green">
                      {{$t('maintenanceDetails.evaluateExperience')}}
                    </div>
                  </div>
                </div>
                <div class="card scheduleDate" v-if="row.scheduleDate">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-auto content-center">
                        <img src="/assets/images/icons/clock-2.png" class="max-24" alt="">
                      </div>
                      <div class="col-4 p-0">
                        <div>
                          {{$t('maintenanceDetails.maintenanceAppointment')}}
                        </div>
                          {{moment(row.scheduleDate).format('LLL')}}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row" v-if="row.rate">
                  <div class="col text-center">
                    <div class="small-Font">{{$t('maintenanceDetails.customerRate')}}</div>
                    <div class="pt-1" id="customerRate"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center" v-if="step == 2">
      <div class="col">
        <h5 class="almarai-regular gray-color">{{$t('maintenanceDetails.maintenanceCost')}}</h5>
        <div>{{row.deposit}}<span>{{$t('maintenanceDetails.onlyRiyal')}}</span></div>
        <div class="row py-3 justify-content-center">
          <div class="col-12 col-md-8">
            <label for="" class="fonttext-14 gray-color almarai-regular py-2">{{$t('maintenanceDetails.tip')}}</label>
            <input type="number" v-model="tip" class="form-control input-style" :placeholder="$t('maintenanceDetails.optionalTip')">
          </div>
        </div>

        <div class="row justify-content-center pt-4">
          <div class="col-8 text-center" v-if="row.finalPayment != 0 && row.status == 'payment_issue' || row.status == 'waiting_payment'">
            <button @click.prevent="poupPaymentOrder" class="form-control btn-green">{{$t('maintenanceDetails.title_5')}} {{row.finalPayment+tip}} {{$t('maintenanceDetails.title_7')}} </button>
          </div>
        </div>

      </div>
    </div>

    <div class="row" v-if="step == 3">
      <div class="col">
        <div class="row justify-content-center pt-3">
          <div class="col-12 text-center">
            <img src="/assets/images/tick-circle.png" alt="">
          </div>
        </div>
        <div class="row pt-3">
          <div class="col text-center">
            <h3 class="font-24 almarai-bold text-center mb-1">{{$t('maintenanceDetails.paymentSuccessful')}}</h3>
            <div class="gray-color almarai-regular">{{$t('maintenanceDetails.honorServe')}}</div>
          </div>
        </div>
        <div class="row py-3 justify-content-center">
          <div class="col-12 col-md-6">
            <router-link to="/maintenanceslist">
              <div class="back almarai-bold text-center">{{$t('maintenanceDetails.backMaintenance')}}</div>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- begin:Rate successfuly confirm -->
    <div class="row" v-if="step == 4">
      <div class="col">
        <div class="row justify-content-center pt-3">
          <div class="col-12 text-center">
            <img src="/assets/images/tick-circle.png" alt="">
          </div>
        </div>
        <div class="row pt-3">
          <div class="col text-center">
            <h3 class="font-24 almarai-bold text-center mb-1">{{$t('maintenanceDetails.successfullyEvaluated')}}</h3>
            <!-- <div class="gray-color almarai-regular">تشرفنا بخدمتك،وبيتك عامر فيك دائماً</div> -->
          </div>
        </div>
        <div class="row py-3 justify-content-center">
          <div class="col-12 col-md-8">
            <router-link to="/maintenanceslist">
              <div class="back almarai-bold text-center">{{$t('maintenanceDetails.backMaintenance')}}</div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- end:Rate successfuly confirm -->

    <!--begin: modal cancelOrder-->
    <div class="modal bg-color-B" tabindex="-1" id="canceled">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{$t('maintenanceDetails.title_6')}}</h5>
            <button type="button" class="btn-close m-0" @click="closePoup" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="row">
            <div class="col">
              <div v-if="hasErrors" class="text-center">
                <errorAlert :alertMessage="message" :errorNumber="errorNumber" />
              </div>
            </div>
          </div>
          <div class="modal-body">
            <h6 class="gray-color-85">{{$t('maintenanceDetails.opinionMatters')}}</h6>
            <div class="row py-3">
              <div class="col">
                <label class="fonttext-14 almarai-regular gray-color">{{$t('maintenanceDetails.title_8')}}</label>
                <select name="" id="" class="form-select input-style" v-model="cancelReason">
                  <option value="" selected>{{$t('maintenanceDetails.title_9')}}</option>
                  <option v-for="(val, key) in client" :value="key" :key="key" >{{val}}</option>
                </select>
              </div>
            </div>
            <div class="row" v-if="!row.arriveTime">
              <div class="col text-center" @click="cancelOrder"> 
                <div class="text-center" v-if="LOADING">
                  <loader />
                </div>
                <button v-else class="form-control btn-green almarai-bold">{{$t('maintenanceDetails.title_6')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end: modal cancelOrder-->

    <!--begin:customer Rating -->
    <div class="modal bg-color-B" tabindex="-1" id="rating-client">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{$t('maintenanceDetails.evaluateExperience')}}</h5>
            <button type="button" class="btn-close m-0" @click="ratingPoupClose" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="row">
            <div class="col-12">
              <div v-if="hasError" class="text-center">
                <errorAlert :alertMessage="message" :errorNumber="errorNumber" />
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="rating-container text-center">
              <div class="rating-emoji">
                
              </div>
              <h3 class="rating-title">{{$t('maintenanceDetails.maintenanceService')}}</h3>
              <h6>{{$t('maintenanceDetails.evaluateExperience')}}</h6>
              <div class="star-rating row">
                <div class="col-auto p-1">
                  <label for="star5">
                    <input type="radio" class="form-check-input" id="star5" v-model="rate" value="5">
                    <div :class="(rate == '5')? 'emoji check-radio-style' : 'emoji'">
                      <img src="/assets/images/icons/emoji-5.png" alt="">
                    </div>
                  </label>
                </div>

                <div class="col-auto p-1">
                  <label for="star4">
                    <input type="radio" class="form-check-input" id="star4" v-model="rate" value="4">
                    <div :class="(rate == '4')? 'emoji check-radio-style' : 'emoji'">
                      <img src="/assets/images/icons/emoji-4.png" alt="">
                    </div>
                  </label>
                </div>

                <div class="col-auto p-1">
                  <input type="radio" class="form-check-input" id="star3" v-model="rate" value="3">
                  <label for="star3">
                    <div :class="(rate == '3')? 'emoji check-radio-style' : 'emoji'">
                      <img src="/assets/images/icons/emoji-3.png" alt="">
                    </div>
                  </label>
                </div>

                <div class="col-auto p-1">
                  <label for="star2">
                    <input type="radio" class="form-check-input" id="star2" v-model="rate" value="2">
                    <div :class="(rate == '2')? 'emoji check-radio-style' : 'emoji'">
                      <img src="/assets/images/icons/emoji-2.png" alt="">
                    </div>
                  </label>
                </div>

                <div class="col-auto p-1">
                  <label for="star1">
                    <input type="radio" class="form-check-input" id="star1" v-model="rate" value="1">
                    <div :class="(rate == '1')? 'emoji check-radio-style' : 'emoji'">
                      <img src="/assets/images/icons/emoji-1.png" alt="">
                    </div>
                  </label>
                </div>
              </div>
              <div class="rating-feedback">
                <div class="gray-color">{{$t('maintenanceDetails.feedback')}}</div>
                <textarea v-model="rateNote" class="form-control bg-area" rows="3" placeholder=""></textarea>
              </div>
              <div class="row justify-content-center">
                <div @click.prevent="ratingOrders" class="col-12 col-md-8 submit-rating">
                  <div>{{$t('maintenanceDetails.btnConfrim')}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:customer Rating -->

    <!-- begin:modal-payment -->
    <button type="button"  id="selectPayment" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#paymentModal">
      </button>
    <div class="modal fade" id="paymentModal" tabindex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header border-0 pb-1">
            <h1 class="modal-title fs-5 pt-2" id="paymentModalLabel">{{$t('wallet.title_12')}}</h1>
            <button type="button" id="closeModal" class="btn-close p-3 m-0" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          <!-- <div class="modal-body">
            <label for="" class="text-style">{{$t('wallet.title_13')}}</label>
            <div class="row pt-3 justify-content-center">
              <div class="col-11 position-R">
                <label for="visa" class=" mouse-hand d-block">
                  <div class="input-style">
                    <input class="form-check-input radio-left" v-model="paymentGate" type="radio" value="online" name="radioDefault" id="visa">
                    <img src="/assets/images/Frame_41.png" class="width-icon" alt="">
                    <span class="mx-2">{{$t('wallet.title_14')}}</span>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-11 position-R">
                <label for="radioDefault1" class=" mouse-hand d-block">
                  <div class="input-style">
                    <input class="form-check-input radio-left" v-model="paymentGate"  value="wallet" type="radio"  name="radioDefault" id="radioDefault1">
                    <img src="/assets/images/icons/img-3.png" class="width-icon" alt="">
                    <span class="mx-2">{{$t('wallet.title_16')}}</span>
                  </div>
                </label>
              </div>
            </div>
            <div class="row pt-5 justify-content-center">
              <div v-if="paymentLoader" class="text-center">
                <loader />
              </div>
              <div class="col text-center" v-if="!paymentLoader && row.deposit !=0 && (row.status == 'waiting_deposit' || row.status == 'deposit_issue')">
                <button @click.prevent="checkPaymentMethod" class="form-control btn-green">{{$t('maintenanceDetails.title_5')}} {{row.deposit}} {{$t('maintenanceDetails.title_7')}} </button>
              </div>
              <div class="col-11 col-md-5 content-center text-center" v-if="!paymentLoader && row.finalPayment != 0 && (row.status == 'payment_issue' || row.status == 'waiting_payment')">
                <button @click.prevent="checkPaymentMethod" class="form-control btn-green">{{$t('maintenanceDetails.title_5')}} {{row.finalPayment}} {{$t('maintenanceDetails.title_7')}} </button>
              </div>
            </div>
          </div> -->
          <div class="modal-body">
            <div class="row py-2">
              <div class="col almarai-bold">
                {{$t('wallet.payment')}}
              </div>
              <div class="col-auto mouse-hand" id="closeModal" data-bs-dismiss="modal" aria-label="Close">
                <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
              </div>
            </div>

            <div class="py-2 gray-color">{{$t('wallet.choosePayment_Method')}}</div>

            <div class="row py-3" v-if="neededPrice">
              <label class="almarai-bold mb-2">{{$t('wallet.cost')}}</label>
              <div class="col-12">
                <div class="d-flex input-style">
                  <span class="gray-color almarai-bold">{{$t('wallet.cost')}}</span>
                  <div class="direction">
                    <span class="mx-2 gray-color almarai-bold">{{neededPrice}}</span>
                    <span>
                      <img src="/assets/images/icons/riyal.png" class="max-16" alt="">
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <label class="almarai-bold pt-2">{{$t('wallet.title_13')}}</label>
            <div class="row pt-3 justify-content-center">
              <div class="col-12 position-R">
                <label for="visa" class=" mouse-hand d-block">
                  <div :class="(paymentGate == 'online')? 'wallet-style priceList' : 'wallet-style'">
                    <input class="form-check-input radio-left select_Radio" v-model="paymentGate" type="radio" value="online" name="radioDefault" id="visa">
                    <img src="/assets/images/icons/bank.png" class="width-icon" alt="">
                    <span class="mx-2 almarai-bold">{{$t('wallet.title_14')}}</span>
                    <span class="bankCard">{{$t('wallet.bankCard')}}</span>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-12 position-R">
                <label for="radioDefault1" class=" mouse-hand d-block">
                  <div :class="(paymentGate == 'wallet')? 'wallet-style priceList' : 'wallet-style'">
                    <input class="form-check-input radio-left select_Radio" v-model="paymentGate"  value="wallet" type="radio"  name="radioDefault" id="radioDefault1">
                    <img src="/assets/images/icons/wallet-3.png" class="width-icon" alt="">
                    <span class="mx-2 almarai-bold">{{$t('wallet.title_16')}}</span>
                    <span class="bankCard">{{$t('wallet.appWallet')}}</span>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-5 justify-content-center">
              <div v-if="paymentLoader" class="text-center">
                <loader />
              </div>
              <div class="col text-center" v-if="!paymentLoader && row.deposit !=0 && (row.status == 'waiting_deposit' || row.status == 'deposit_issue')">
                <button @click.prevent="checkPaymentMethod" class="form-control btn-green">{{$t('maintenanceDetails.title_5')}} {{row.deposit}} {{$t('maintenanceDetails.title_7')}} </button>
              </div>
              <div class="col-11 col-md-5 content-center text-center" v-if="!paymentLoader && row.finalPayment != 0 && (row.status == 'payment_issue' || row.status == 'waiting_payment')">
                <button @click.prevent="checkPaymentMethod" class="form-control btn-green">{{$t('maintenanceDetails.title_5')}} {{row.finalPayment}} {{$t('maintenanceDetails.title_7')}} </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end:modal-payment -->
    
    <!--begin:popup wallet balance -->
    <button type="button"  id="popup_Wallet" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#popup_WalletBalance">
      </button>
    <div class="modal bg-color-B" tabindex="-1" id="popup_WalletBalance">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header headerWallet">
            <button type="button" class="btn-close m-0" id="closeWalletBalance" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <h6 class="modal-title text-center almarai-bold pt-3">{{$t('walletPaymentConfirmation')}}</h6>
          <div class="modal-body">
            <div class="row" v-if="paymentGate == 'wallet'">
              <div class="col-auto almarai-bold content-center">{{$t('walletBalance')}}</div>
              <div class="col text-start">
                {{USER_WALLET_BALANCE}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row">
              <div class="col-auto almarai-bold content-center">{{$t('totalOrder')}}</div>
              <div class="col text-start">
                {{neededPrice}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row" v-if="paymentGate == 'wallet'">
              <div class="col-auto almarai-bold content-center">{{$t('remainingBalance')}}</div>
              <div class="col text-start">
                {{remainingBalance}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row justify-content-center pt-3">
              <div v-if="paymentLoader" class="text-center">
                <loader />
              </div>
              <div v-else class="col-12 col-md-6 text-center" @click.prevent="confirmPay">
                <div class="btn-black">{{$t('confirmButton')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:popup wallet balance -->

    <!--begin:Charge your wallet -->
    <div class="modal bg-color-B" tabindex="-1" id="chargeWallet">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header headerWallet">
            <button type="button" class="btn-close m-0" @click="closePopupCharge" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <h6 class="modal-title text-center almarai-bold pt-3">{{$t('balanceInsufficient')}}</h6>
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col text-center">
                <div class="small-Font">{{$t('chargeWallet')}}</div>
              </div>
            </div>

            <div class="row pt-3">
              <div class="col">
                <router-link to="/wallet">
                  <div class="btn-green fonttext-14">{{$t('btnChargeWallet')}}</div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:Charge your wallet -->

    <div v-if="currentChat" class="mini-chat-container">
      <div class="mini-chat-body" id="miniChatBody">
        <div id="miniChatMessages">
          <div v-for="message in currentChatMessages" :key="message.id">
              <div class="row mb-3" :style="(message.user.id != GET_USER_DATA.streamId)? 'direction: ltr;' : ''">
                  <div class="col-auto">
                      <div class="chat-img" :style="`background-image: url(${(message.user.image)? message.user.image : '/assets/images/user.png'})`"></div>
                  </div>
                  <div class="col pt-2">
                      <strong>{{ message.user.name }}</strong>
                      <p>{{ message.text }}</p>
                  </div>
              </div>
          </div>
        </div>
        <div class="mini-chat-form">
          <form action="" @submit.prevent="sendMessage">
            <div class="container">
              <div class="row">
                <div class="col">
                  <input type="text" v-model="messageText" class="form-control">
                </div>
                <div class="col-auto">
                  <input type="submit" class="btn btn-warning" :value="$t('nafath.submit')" :disabled="messageLoader">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="btn-Close" @click="toggleDiv">{{$t('close')}}</div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- <div class="mini-chat-toggle" @click="toggleDiv"><i class="fa-regular fa-comment-dots"></i> {{ $t('maintenances.chat') }} <span v-if="unreadCount" class="badge text-bg-danger">{{ unreadCount }}</span></div> -->
    </div>

    <!-- begin:helpPopup -->
    <button type="button" id="helping" class="hidden-fileds" data-bs-toggle="modal" data-bs-target="#exampleModal"></button>
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-Max320">
        <div class="modal-content">
          <!-- <div class="modal-header">
            <h1 class="modal-title fs-5" id="exampleModalLabel">Modal title</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          <div class="modal-body">
            <ul class="p-2">
              <li class="dropdown-item mouse-hand" data-bs-toggle="modal" data-bs-target="#contactUsChat">
                <img src="/assets/images/icons/Button_chat.png" alt="" class="mx-2 max-40" />
                <span class="">{{$t('SpeakcustomerService')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left chevronStyle"></i>
                <i  v-else class="fa-solid fa-chevron-right"></i>
              </li>
              <li class="dropdown-item mouse-hand pt-3" v-if="(row.status !='done'|| row.status !='admin_done')  && row.status !='client_canceled' && row.status !='provier_canceled'" 
                @click.prevent="poupCanenllOrder">
                <img src="/assets/images/icons/Button_Close.png" alt="" class="mx-2 max-40" />
                <span class="">{{$t('cancelMaintenance')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left chevronStyle"></i>
                <i  v-else class="fa-solid fa-chevron-right"></i>
              </li>
            </ul>
          </div>
          <!-- <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Save changes</button>
          </div> -->
        </div>
      </div>
    </div>
    <!-- end:helpPopup -->

    
    <button type="button" id="changeProviderList" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target= "#provider">
      Launch demo modal
    </button>

    <!-- Modal -->
    <div class="modal fade" id="provider" tabindex="-1" aria-labelledby="providerLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content p-3">
          <!-- <div class="modal-header">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          <h1 class="modal-title fs-5">{{$t('maintenanceDetails.ProblemTechnician')}}</h1>
          <span class="avoidProblem">{{$t('maintenanceDetails.avoidProblem')}}</span>
          <div class="modal-body">
            <ul class="reasign">
              <li v-for="(reasign, indexKey) in orderReasignReasonsArray" :key="indexKey"
                :class="(reasignReason == reasign.key)? 'active-reasign dropdown-item mouse-hand':'dropdown-item mouse-hand'">
                <label class="reasign-Style" :for="reasign.key">
                  <input class="form-check-input radio hidden-fileds" v-model="reasignReason" type="radio" :value="reasign.key" name="radioDefault" :id="reasign.key">
                  {{reasign.value}}
                  <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left chevronStyle"></i>
                  <i v-else class="fa-solid fa-chevron-right"></i>
                </label>
              </li>
            </ul>
          </div>
          <div class="modal-footer justify-content-start">
            <div class="row">
              <div class="col-auto">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{$t('closing')}}</button>
              </div>
              <loader v-if="loading" />
              <div  v-else class="col-auto">
                <button @click.prevent="changeProviderFN" type="button" class="btn bg-Gold">{{$t('send')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Button chat modal -->
    <div class="modal fade" id="contactUsChat" tabindex="-1" aria-labelledby="contactUsChatLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-6" id="contactUsChatLabel">{{$t('nav.supportChat')}}</h1>
            <button type="button" id="chatCloseBtn" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form action="" @submit.prevent="startChat">
              <div v-if="chatError" class="row">
                <div class="col mb-3">
                  <div class="alert alert-danger">{{ errorMsg }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col mb-3">
                  <input type="text" v-model="chatTitle" class="form-control" :placeholder="$t('nav.chatTitle')">
                </div>
              </div>
              <div class="row">
                <div class="col text-start">
                  <input type="submit" class="btn btn-warning" :value="$t('nav.chatSend')">
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- end:chat modal -->

    <!-- Button trigger modal -->
    <button type="button" id="confirmChangeProvider" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#confirmProvider">
      Launch demo modal
    </button>

    <!-- Modal -->
    <div class="modal fade" id="confirmProvider" tabindex="-1" aria-labelledby="confirmProviderLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header">
            <h1 class="modal-title fs-5" id="exampleModalLabel">Modal title</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          <div class="modal-body">
            <div class="row">
              <div class="col">
                <div class="row justify-content-center pt-3">
                  <div class="col-12 text-center">
                    <img src="/assets/images/icons/true-circle.png" class="max-50" alt="">
                  </div>
                </div>
                <div class="row pt-3">
                  <div class="col text-center">
                    <div class="font-24 almarai-bold">
                      {{$t('technicianChange_received')}}
                    </div>
                  </div>
                  <div class="col-12 pt-2 gray-color">
                    <div class="text-center">{{$t('sendingAnother_suitable')}}</div>
                    <div class="text-center">{{$t('soonPossible')}}</div>
                  </div>
                </div>
                <div class="row py-3 justify-content-center">
                  <div class="col-12 col-md-6">
                    <div class="back" data-bs-dismiss="modal" aria-label="Close">
                      {{$t('thanks')}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Save changes</button>
          </div> -->
        </div>
      </div>
    </div>

    <!-- modal: Order has been cancelled. -->
    <div class="modal" tabindex="-1" id="orderCancelled">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row">
              <div class="col">
                <div class="row justify-content-center pt-3">
                  <div class="col-12 text-center">
                    <img src="/assets/images/icons/true-circle.png" class="max-50" alt="">
                  </div>
                </div>
                <div class="row pt-3">
                  <div class="col text-center">
                    <div class="font-24 almarai-bold">
                      {{$t('maintenanceDetails.successfullyCancelled')}}
                    </div>
                  </div>
                  <div class="col-12 pt-2 gray-color">
                    <div class="text-center">{{$t('maintenanceDetails.reasonCancellation')}}</div>
                  </div>
                </div>
                <div class="row py-3 justify-content-center">
                  <div class="col-12 col-md-10">
                    <router-link to="/maintenanceslist">
                      <div class="btn-black">{{$t('maintenanceDetails.maintenanceRequest')}}</div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end: Order has been cancelled. -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import moment from 'moment';
import 'moment/locale/ar';
import 'moment/locale/en-gb';
import { toast } from "../../helpers/tools";

export default {
  name: "maintenancedetails",
  data(){
    return{
      hasError: false,
      message: "",
      errorNumber: "",
      maintenanceID: this.$route.params.id,
      isLoading: true,
      row:{},
      status: {},
      client: {},
      formattedTime: null,
      hours: null,
      minutes: null,
      nowTime: null,
      LOADING: false,
      cancelReason: "",
      currentStage: 'created',
      userLang: 'ar',
      tip: null,
      paymentGate: '',
      step: 1,
      value: null,
      rating: "",
      ratProvider: "",
      rate: null,
      rateNote: "",
      billUrl: null,
      neededPrice: 0,
      remainingBalance: 0,
      paymentLoader: false,
      hasErrors: false,
      currentChat: null,
      currentChatCID: null,
      currentChatMessages: [],
      messageText: '',
      messageLoader: false,
      chatMessageEvent: null,
      usersName: {},
      unreadCount: 0,
      orderReasignReasonsArray:[],
      reassignReason: "",
      chatTitle: '',
      errorMsg: '',
      chatError: false,
      reasignReason: "",
      loading: false,
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL', 'BASE_URL', 'USER_WALLET_BALANCE', 'GET_USER_DATA', 'CHAT_CLIENT'])
  },

  methods:{
    maintenanceRetrieve(){
      this.hasError = false;
      this.$http.get("/api/orders/retrieve/"+this.maintenanceID).then(res => {
        // console.log(res);
        this.row = res.data.row;
        this.status = res.data.orderStatus;
        this.client = res.data.orderCancelClient;
        this.orderReasignReasonsArray = res.data.orderReasignReasonsArray;

        const statusAllowChat = ['assigned', 'arrived', 'hold', 'waiting_payment', 'payment_issue'];
        if(res.data.row.lastChannelId && statusAllowChat.indexOf(res.data.row.status) != -1){
          this.getChannel(res.data.row.lastChannelId);
        }
        if(this.row.doneTime){
          this.currentStage = 'done';
        }else if(this.row.arriveTime){
          this.currentStage = 'arrive';
        }else if(this.row.assignTime){
          this.currentStage = 'assign';
        }
        
        this.isLoading = false;
        if((res.data.row.status == 'done' || res.data.row.status == 'admin_done') && res.data.row.rate == 0){
          this.ratingPoup();
        }
        if((this.row.status !='done' || this.row.status !='admin_done') && res.data.row.Provider){
          setTimeout(()=> {
            this.renderStars(res.data.row.Provider.rate);
          },1000)
        }
        if(res.data.row.rate){
          setTimeout(()=> {
            this.renderCustomer(res.data.row.rate);
          },1200)
        }
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },
    moment,
    formatDate(){
      this.nowTime = new Date();
      this.hours = this.nowTime.getHours().toString().padStart(2, '0');
      this.minutes = this.nowTime.getMinutes().toString().padStart(2, '0');
      this.formattedTime = `${this.hours}:${this.minutes}`;
      // console.log(this.formattedTime); 
    },
    cancelOrder(){
      this.hasErrors = false;
      this.LOADING = true;
      this.$http.post("/api/orders/cancel/"+this.maintenanceID,{
        cancelReason : this.cancelReason,
      }).then(res => {
        // console.log(res);
        // this.$router.push({path : "/maintenances" });
        document.getElementById('orderCancelled').style.display ="block";
        this.LOADING = false;
      }).catch(err => {
        // console.log(err);
        this.LOADING = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasErrors = true;
      });
    },

    closeOpenedModales(){
      const modalDiv1 = document.getElementById('paymentModal');
      if(modalDiv1 && modalDiv1.style.display == 'block'){
        document.getElementById('closeModal').click();
      }
      const modalDiv2 = document.getElementById('popup_WalletBalance');
      if(modalDiv2 && modalDiv2.style.display == 'block'){
        document.getElementById('closeWalletBalance').click();
      }
    },

    payDepost(){
      this.payError = false;
      this.hasError = false;
      this.submitLoading = true;
      this.$http.post("/api/orders/depostPay/"+this.maintenanceID,{
        paymentGate: this.paymentGate,
      }).then(res => {
        // console.log(res);
        if(res.data.paymentUrl){
          window.location.href = res.data.paymentUrl;
        }else{
          if(this.paymentGate == 'wallet'){
            this.$store.dispatch('checkUser');
          }
          this.step = 3;
        }
        this.closeOpenedModales();
        this.submitLoading = false;
        this.paymentLoader = false;
      }).catch(err => {
        // console.log(err);
        this.submitLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.payError = true;
        window.scroll(0,0);
        this.closeOpenedModales();
        this.hasError = true;
        this.paymentLoader = false;
      });
    },

    paymentFN(){
      this.hasError = false;
      this.$http.post('/api/orders/pay',{
        orderId: this.maintenanceID,
        tip: this.tip,
        paymentGate: this.paymentGate,
      }).then(res => {
        // console.log(res);
        if(res.data.paymentUrl){
          window.location.href = res.data.paymentUrl;
        }else{
          if(this.paymentGate == 'wallet'){
            this.$store.dispatch('checkUser');
          }
          this.step = 3;
        }
        this.closeOpenedModales();
        this.paymentLoader = false;
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        window.scroll(0,0);
        this.closeOpenedModales();
        this.hasError = true;
        this.paymentLoader = false;
      });
    },

    poupCanenllOrder(){
      document.getElementById('helping').click();
      document.getElementById("canceled").style.display = "block";
    },

    closePoup(){
      document.getElementById("canceled").style.display = "none";
    },
    next(){
      this.step = 2;
    },

    poupPaymentOrder(){
      document.getElementById('selectPayment').click();
    },

    ratingOrders(){
      this.$http.post('/api/orders/rate/'+this.maintenanceID,{
        rate:this.rate,
        rateNote: this.rateNote,
      }).then(res => {
        // console.log(res);
        document.getElementById('rating-client').style.display = 'none';
        this.step = 4;
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scroll(0,0);
      })
    },

    ratingPoup(){
      document.getElementById('rating-client').style.display = 'block';
    },
    ratingPoupClose(){
      document.getElementById('rating-client').style.display = 'none';
    },

    renderStars(ratingProvider) {
      const max = 5;
      let container = document.getElementById('providerRate');
      // console.log(container);
      // console.log(rating);
      
      for (let i = 1; i <= max; i++) {
      const icon = document.createElement('i');
      // full star
      if (ratingProvider >= i) {
      icon.className = 'fa-solid fa-star bg-star';
      icon.setAttribute('aria-hidden','true');
      }
      // half star (e.g. rating = 3.5 -> when i=4, rating >= 3.5)
      else if (ratingProvider >= i - 0.5) {
      icon.className = 'fa-solid fa-star-half-alt bg-star';
      icon.setAttribute('aria-hidden','true');
      }
      // empty star
      else {
      icon.className = 'far fa-star fonttext-14';
      icon.setAttribute('aria-hidden','true');
      }
      container.appendChild(icon);
      }
    },

    renderCustomer(ratingCustomer) {
      const max = 5;
      let container = document.getElementById('customerRate');
      for (let i = 1; i <= max; i++) {
      const icon = document.createElement('i');
      if (ratingCustomer >= i) {
      icon.className = 'fa-solid fa-star bg-star';
      icon.setAttribute('aria-hidden','true');
      }
      else if (ratingCustomer >= i - 0.5) {
      icon.className = 'fa-solid fa-star-half-alt bg-star';
      icon.setAttribute('aria-hidden','true');
      }
      else {
      icon.className = 'far fa-star fonttext-14';
      icon.setAttribute('aria-hidden','true');
      }
      container.appendChild(icon);
      }
    },

    billGenerate(){
      this.$http.get('/api/bills/MaintenanceOrders/'+this.maintenanceID).then(res => {
        if(res.data.url)
          this.billUrl = res.data.url;
      }).catch(() => {});
    },
    confirmPay(){
      this.paymentLoader = true;
      if(this.row.deposit !=0 && (this.row.status == 'waiting_deposit' || this.row.status == 'deposit_issue'))
        this.payDepost();
      if(this.row.finalPayment != 0 && (this.row.status == 'payment_issue' || this.row.status == 'waiting_payment'))
        this.paymentFN();
    },
    checkPaymentMethod(){
      if(this.paymentGate == 'wallet'){
        const confirmDiv = document.getElementById('paymentModal');
        if(confirmDiv && confirmDiv.style.display == 'block'){
          document.getElementById('closeModal').click();
        }
        
        this.neededPrice = 0;
        if(this.row.deposit !=0 && (this.row.status == 'waiting_deposit' || this.row.status == 'deposit_issue'))
          this.neededPrice = this.row.deposit;
        if(this.row.finalPayment != 0 && (this.row.status == 'payment_issue' || this.row.status == 'waiting_payment'))
          this.neededPrice = this.row.finalPayment;
        this.remainingBalance = this.USER_WALLET_BALANCE - this.neededPrice;
        if(this.neededPrice > this.USER_WALLET_BALANCE){
          document.getElementById('chargeWallet').style.display = 'block';
        } else {
          document.getElementById('popup_Wallet').click();
        }
      }else{
        this.confirmPay();
      }
    },
    closePopupCharge(){
      document.getElementById('chargeWallet').style.display = 'none';
    },
    getChannel(id){
      if(this.chatMessageEvent)
        this.chatMessageEvent.unsubscribe();
      this.currentChatCID = id;
      this.currentChat = null;
      this.currentChatMessages = [];
      const filter = {type: "messaging", cid: {$eq: `messaging:${id}`}};
      const sort = [{ last_message_at: -1 }];
      const options = {
        limit: 1, //watch: true,
      };
      this.CHAT_CLIENT.queryChannels(filter, sort, options).then(async row => {
        this.currentChat = row[0];
        this.currentChatMessages = row[0].state.messages;
        this.unreadCount = this.currentChat.state.unreadCount;
        await this.currentChat.watch();
        await this.currentChat.markRead();
        setTimeout(() => this.chatScroll(), 200);

        this.chatMessageEvent = this.currentChat.on("message.new", (event) => {
          this.currentChatMessages = this.currentChat.state.messages;
          this.unreadCount = this.currentChat.state.unreadCount;
          this.chatScroll();
        });
      }).catch(() => {});
    },
    chatScroll(){
      const div = document.getElementById('miniChatMessages');
      if(div){
        setTimeout(() => {
          div.scrollTo({
            top: div.scrollHeight,
            behavior: 'smooth'
          });
        }, 200);
      }
    },
    sendMessage(){
      if(!this.messageText || this.messageText.trim() == ''){
        toast('يجب كتابة الرسالة اولاً');
        return false;
      }
      if(!this.currentChat){
        toast('لا يمكنك إرسال الرسالة');
        return false;
      }
      this.messageLoader = true;
      this.currentChat.sendMessage({
        text: this.messageText,
      }).then(() => {
        this.messageText = '';
        this.messageLoader = false;
      }).catch(err => {
        toast('غير قادر على إرسال الرسالة');
        this.messageLoader = false;
      });
    },
    toggleDiv() {
      const el = document.getElementById("miniChatBody");
      if(el){
        if (el.style.display === "none" || el.style.display == "") {
          // document.getElementById('helping').click();
          el.style.display = "block";
        } else {
          el.style.display = "none";
        }
      }
    },

    openPoup(){
      document.getElementById('helping').click();
    },

    requestChangeProvider(){
      document.getElementById('changeProviderList').click();
    },

    changeProviderFN(){
      this.loading = true;
      this.$http.post('/api/orders/changeProvider',{
        id: parseInt(this.maintenanceID),
        reassignReason: this.reasignReason,
      }).then(res => {
        console.log(res);
        document.getElementById('confirmChangeProvider').click();
        this.loading = false;
      }).catch(err => {
        console.log(err);
      })
    },

    startChat(){
      this.chatError = false;
      if(!this.chatTitle || this.chatTitle.trim().length < 5){
        this.errorMsg = this.$t('nav.chantTitleRequired');
        this.chatError = true;
        return;
      }

      this.$http.post('/api/chats/createContactChannel', {
        title: this.chatTitle,
      }).then(({data}) => {
        const filter = {type: "messaging", cid: {$eq: `messaging:${data.channelId}`}};
        const sort = [{ last_message_at: -1 }];
        const options = {
          limit: 1, //watch: true,
        };
        this.CHAT_CLIENT.queryChannels(filter, sort, options).then(channel => {
          channel[0].sendMessage({
            text: this.chatTitle,
          }).then(() => {
            const closeBtn = document.getElementById('chatCloseBtn');
            if(closeBtn)
              closeBtn.click();
            this.$router.push({path : '/chats', query: { id: data.channelId }});
          }).catch(err => {
            this.errorMsg = this.$t('nav.chatCantSend');
            this.chatError = true;
          });
        }).catch(err => {
          this.errorMsg = this.$t('nav.chatCantSend');
          this.chatError = true;
        });
      }).catch(err => {
        this.errorMsg = this.$t('nav.chatCantSend');
        this.chatError = true;
      });
    },
  },

  created(){
    this.maintenanceRetrieve();
    this.formatDate();
    this.billGenerate();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
    window.scrollTo({top:0, behavior: 'smooth'});
  },
  
}
</script>
<style>
.mini-chat-container {
  position: fixed;
  bottom: 5px;
  border-radius: 5px 5px 0px 0px;
  border: 1px solid #DDD;
  white-space: nowrap;
  width: 500px;
  max-width: 100%;
  left: 10px;
  z-index: 5;
}
.mini-chat-body {
  padding-bottom: 10px;
  background: white;
  display: none;
}
#miniChatMessages {
  height: 250px;
  overflow-y: scroll;
  padding: 10px 5px;
}
.mini-chat-form {
  padding-top: 10px;
  border-top: 1px solid #DDD;
}
.mini-chat-toggle {
  padding: 10px;
  border-top: 1px solid #DDD;
  background: #fffde1;
  text-align: center;
  font-weight: bold;
  cursor: pointer;
}
</style>
